// extracted by mini-css-extract-plugin
export var chip = "_g4-0";
export var filterDropdown = "_g4-5";
export var filterItem = "_g4-6";
export var icon = "_g4-1";
export var removeButton = "_g4-3";
export var removeIcon = "_g4-4";
export var separator = "_g4-2";